import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';
import { each, upperCase } from 'lodash-es';

export default class GetTeams extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-getTeams',
      payload: this._payload
        ? {
            resolve_links: this._payload.resolve_links || false,
            skip: this._payload.skip || null,
            limit: this._payload.limit || null,
            search_fields: this._payload.search_fields || null,
          }
        : {},
    });
  }

  onSuccess(data) {
    if (this._payload.concat) {
      data = this._state.admin.teams.data.concat(data);
    }
    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        admin: {
          teams: {
            tabledData: this.formatToTable(data),
            data: data,
          },
        },
      },
    });
    super.onSuccess(data);
  }

  /**
   * Prepare users data for flat datatable formatting
   */
  formatToTable = (data) => {
    const tableData = [];
    each(data, (team) => {
      tableData.push([
        upperCase(`${team.name}`),
        upperCase(`${team.group}`),
        upperCase(`${team.gender}`),
        // Total Members
        Object.keys(team.members).length.toString(),
        `${team.doc_id}`,
        // Raw Data
        team,
      ]);
    });
    return tableData;
  };
}
